import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const reclassification: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldClass' },
            { type: 'field', field: 'reClassType' },
            { type: 'field', field: 'reclassTerms' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'newClass' },
            { type: 'field', field: 'reclassRatio' },
        ],
    },
];

export default reclassification;
